import { useState, useEffect } from 'react';
import { dashboardService } from '../../services';

export const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const data = await dashboardService.getAnnouncements();
        setAnnouncements(data);
      } catch (err) {
        console.error('Failed to fetch announcements:', err);
      }
    };

    fetchAnnouncements();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  if (announcements.length === 0) {
    return (
      <div className="announcements-card">
        <div className="announcements-header">Announcements</div>
        <div className="announcement-item">
          <p style={{ color: 'var(--color-gray-500)', fontSize: 'var(--font-size-sm)' }}>
            No announcements at this time
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="announcements-card">
      <div className="announcements-header">Announcements</div>
      {announcements.map(announcement => (
        <div key={announcement.id} className="announcement-item">
          <span className={`announcement-type ${announcement.type}`}>
            {announcement.type}
          </span>
          <div className="announcement-title">{announcement.title}</div>
          <div className="announcement-date">{formatDate(announcement.createdAt)}</div>
        </div>
      ))}
    </div>
  );
};

export default Announcements;
